module.exports = {"title":"Signature","please_sign":"Please sign below","your_signature":"Your signature","continue":"Continue"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/signature.json
// module id = 667
// module chunks = 247 1429